import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useEffect, useState } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { ReportSection } from './ReportSection';
import { ReviewingStepMark } from './ReviewingStepMark';

const kSteps = ['整理对话', '对照评分标准', '挑出值得重练的时刻'];
const kStepMs = 2_000;
/** After this long, a word that it is still coming. */
const kLongWaitMs = 15_000;

/**
 * 正在复盘, as steps rather than a bare spinner. The steps are paced here,
 * not by the server: the last one holds until the report is in.
 */
export const ReviewingSteps = memo(() => {
  const { rpx } = useResponsiveContext();
  const [step, setStep] = useState(0);
  const [long, setLong] = useState(false);
  useEffect(() => {
    const timer = setInterval(
      () => setStep(x => Math.min(x + 1, kSteps.length - 1)),
      kStepMs,
    );
    const wait = setTimeout(() => setLong(true), kLongWaitMs);
    return () => {
      clearInterval(timer);
      clearTimeout(wait);
    };
  }, []);
  return (
    <View
      style={{
        width: '100%',
        maxWidth: rpx(860),
        alignSelf: 'center',
        padding: rpx(16),
      }}
    >
      <ReportSection style={{ gap: rpx(16) }}>
        <Typography.Text size={rpx(18)} bold color={aiColors.foreground}>
          正在复盘
        </Typography.Text>
        <View style={{ gap: rpx(14) }}>
          {kSteps.map((text, i) => (
            <View
              key={text}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                gap: rpx(12),
              }}
            >
              <ReviewingStepMark
                state={i < step ? 'done' : i === step ? 'active' : 'waiting'}
              />
              <Typography.Text
                size={rpx(14)}
                bold={i === step || undefined}
                color={
                  i <= step ? aiColors.foreground : aiColors.mutedForeground
                }
              >
                {text}
              </Typography.Text>
            </View>
          ))}
        </View>
        {long ? (
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            还在复盘，马上就好
          </Typography.Text>
        ) : null}
      </ReportSection>
    </View>
  );
});
